import React from "react";

const palette = {
  // acid green — match/pass/qualified
  accent: "bg-theme-accent-muted border-theme-accent/50 text-theme-accent",
  // amber — warning/partial
  amber: "bg-theme-surface border-[#6b5a1f] text-[#d4aa40]",
  // muted — neutral/pending
  muted: "bg-theme-surface border-theme-border text-theme-muted",
  neutral: "bg-theme-surface border-theme-border text-theme-text",
  // legacy alias
  teal: "bg-theme-accent-muted border-theme-accent/50 text-theme-accent",
  /** No palette colors; use className only (e.g. score gradient utilities). */
  inherit: "",
};

const Badge = ({ children, variant = "neutral", tone, className = "" }) => {
  const key = tone || variant;
  const paletteClass = key === "inherit" ? "" : palette[key] || palette.neutral;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.08em] ${paletteClass} ${className}`.trim()}
    >
      {children}
    </span>
  );
};

export default Badge;
